import { velilerData } from "@/mocks/veliler";

export default function VelilerStats() {
  const total = velilerData.length;
  const aktif = velilerData.filter((v) => v.ogrenciDurumu === "Aktif").length;
  const referansVeren = velilerData.filter((v) => v.referansDurumu === "Verdi").length;
  const referansVermeyen = velilerData.filter((v) => v.referansDurumu === "Vermedi").length;
  const today = new Date();
  const odemeyaklaşan = velilerData.filter((v) => {
    const gun = today.getDate();
    return Math.abs(v.odemeGunu - gun) <= 3;
  }).length;
  const taahhutYaklaşan = velilerData.filter((v) => {
    const bitis = new Date(v.taahhutBitis);
    const diffDays = Math.ceil((bitis.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    return diffDays <= 30 && diffDays >= 0;
  }).length;

  const stats = [
    { label: "Toplam Kayıt", value: total, icon: "ri-team-line", color: "emerald" },
    { label: "Aktif Öğrenci", value: aktif, icon: "ri-user-follow-line", color: "sky" },
    { label: "Referans Veren", value: referansVeren, icon: "ri-user-add-line", color: "violet" },
    { label: "Referans Vermeyen", value: referansVermeyen, icon: "ri-user-unfollow-line", color: "orange" },
    { label: "Ödeme Günü Yaklaşan", value: odemeyaklaşan, icon: "ri-money-cny-circle-line", color: "amber" },
    { label: "Taahhüdü Yaklaşan", value: taahhutYaklaşan, icon: "ri-file-list-3-line", color: "red" },
  ];

  const colorMap: Record<string, { bg: string; icon: string; num: string }> = {
    emerald: { bg: "bg-emerald-50", icon: "text-emerald-600", num: "text-emerald-700" },
    sky: { bg: "bg-sky-50", icon: "text-sky-600", num: "text-sky-700" },
    violet: { bg: "bg-violet-50", icon: "text-violet-600", num: "text-violet-700" },
    orange: { bg: "bg-orange-50", icon: "text-orange-600", num: "text-orange-700" },
    amber: { bg: "bg-amber-50", icon: "text-amber-600", num: "text-amber-700" },
    red: { bg: "bg-red-50", icon: "text-red-600", num: "text-red-700" },
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {stats.map((s, i) => {
        const c = colorMap[s.color];
        return (
          <div key={i} className="bg-white rounded-2xl p-5 border border-gray-100 hover:shadow-md transition-shadow cursor-pointer">
            <div className={`w-9 h-9 flex items-center justify-center rounded-xl ${c.bg} mb-3`}>
              <i className={`${s.icon} text-base ${c.icon}`}></i>
            </div>
            <p className={`text-2xl font-bold ${c.num} mb-1`}>{s.value}</p>
            <p className="text-xs text-gray-500 leading-tight">{s.label}</p>
          </div>
        );
      })}
    </div>
  );
}